var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTropheeGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBD55D;}\r\n\t.st1{fill:#2D3545;}\r\n\t.st2{fill:#474E5E;}\r\n\t.st3{fill:#FABA26;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.1;fill:#010101;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.9,121.5v-14.4c0-0.3,0-0.4,0-0.4v-2.2H89.5v2.2c0,0,0,0.1,0,0.4v14.4c0,15.8-8.9,19.4-8.9,19.4h38.1 C118.7,141,109.9,137.4,109.9,121.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 191.6,
    className: "st1",
    width: 84.9,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.1,186.6H62.3c-2.8,0-5.1,2.3-5.1,5.1v0h84.9v0C142.1,188.8,139.9,186.6,137.1,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.3,151.6H71.1c-4.8,0-8.8,3.9-8.8,8.8v26.2h74.8v-26.2C137.1,155.5,133.1,151.6,128.3,151.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 141,
    className: "st3",
    width: 38.1,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.8,20.2V9.5H51.6v10.8H26v21.4c0,4.8,0.9,9.5,2.8,13.9c1.8,4.3,4.4,8.1,7.7,11.4c3.3,3.3,7.1,5.9,11.4,7.7 c2.8,1.2,5.7,2,8.7,2.4C64.4,93,80.7,104,99.7,104h0c18.9,0,35.3-10.9,43.2-26.9c3-0.4,5.9-1.3,8.7-2.4c4.3-1.8,8.1-4.4,11.4-7.7 c3.3-3.3,5.9-7.1,7.7-11.4c1.9-4.4,2.8-9.1,2.8-13.9V20.2H147.8z M34.9,41.7V29.2h16.7v26.7c0,3.9,0.5,7.6,1.3,11.2 C42.4,63.4,34.9,53.4,34.9,41.7z M164.5,41.7c0,11.7-7.5,21.7-18,25.4c0.9-3.6,1.3-7.3,1.3-11.2V29.2h16.7V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.1,9.5v41.3c0,26.6-21.5,48.1-48.1,48.1h0c-2.8,0-5.6-0.2-8.2-0.7c6.8,3.7,14.6,5.8,23,5.8h0 c26.6,0,48.1-21.5,48.1-48.1V9.5H133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,100.2v3.8c0,1.5,1.2,2.8,2.8,2.8h20.4c1.5,0,2.8-1.2,2.8-2.8v-3.8H86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.3,0H49.1c-2.6,0-4.7,2.1-4.7,4.7l0,0c0,2.6,2.1,4.7,4.7,4.7h101.1c2.6,0,4.7-2.1,4.7-4.7l0,0 C155,2.1,152.9,0,150.3,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,3.4h-7.8c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h7.8c0.8,0,1.4-0.6,1.4-1.4S58.4,3.4,57.6,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.2,3.4h-2.7c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h2.7c0.8,0,1.4-0.6,1.4-1.4S68,3.4,67.2,3.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,146.7H77.4c-2.7,0-4.8,2.2-4.8,4.8v0h54.2v0C126.8,148.9,124.6,146.7,122,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.6,154v8.6c0,9.7-7.9,17.6-17.6,17.6H62.3v-19.9c0-4.8,3.9-8.8,8.8-8.8h56.2 C127.5,152.3,127.6,153.2,127.6,154z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 9.5,
    className: "st5",
    width: 96.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.2,174v-9.9c-1.5,0-2.7-1.2-2.7-2.7H83.8c0,1.5-1.2,2.7-2.7,2.7v9.9c1.5,0,2.7,1.2,2.7,2.7h31.7 C115.5,175.2,116.8,174,118.2,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 115.8,
    cy: 169.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 83.5,
    cy: 169.1,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTropheeGold);
export default __webpack_public_path__ + "static/media/trophee-gold.23a24121261f94526afcb96501ff2553.svg";
export { ForwardRef as ReactComponent };